import { CRUD } from "@/shared/components";
import {
  ContractPaymentsListQuery,
  type ContractPaymentsListRow,
} from "@/admin/entities/contractPayments";
import { BillingPaymentsConfig, BillingPaymentsSchemas } from "../model";

/**
 * Платежи всех организаций. Только чтение и смена статуса: платежи рождает
 * расписание контракта и закрытие месяца. Сортировка по сроку оплаты стоит
 * на сервере (спека §5).
 */
export function BillingPayments() {
  return (
    <CRUD<ContractPaymentsListRow>
      listQuery={ContractPaymentsListQuery}
      getTableData={BillingPaymentsConfig.getTableData}
      mapColumns={BillingPaymentsConfig.mapColumns}
      columns={BillingPaymentsConfig.getColumnsConfig()}
      totalSchema={BillingPaymentsConfig.getTotalSchema()}
      filterSchema={BillingPaymentsSchemas.filterSchema}
      editSchema={BillingPaymentsSchemas.editSchema}
      normalizeFilter={BillingPaymentsSchemas.normalizeFilter}
      texts={BillingPaymentsConfig.getTextsConfig()}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={BillingPaymentsConfig.getMobileColumnsConfig()}
    />
  );
}
